<template>
    <div
        class="app-container"
        v-loading="openloading"
        element-loading-text="加载中"
        element-loading-background="rgba(0, 0, 0, 0.1)"
    >
        <el-row style="padding-bottom: 15px">
            <el-col :span="24">
                <h3 class="headtitle">用户</h3>
                <span>管理用户及权限</span>
                <el-button
                    icon="el-icon-plus"
                    type="primary"
                    class="pull-right"
                    @click="add"
                    v-if="isGranted('Pages.Administration.Users.Create')"
                    size="medium"
                    >添加用户</el-button
                >
                <el-button
                    icon="el-icon-download"
                    plian
                    class="pull-right right-5"
                    @click="excel"
                    size="medium"
                    >导出到excel</el-button
                >
            </el-col>
        </el-row>
        <el-card>
            <el-row>
                <el-col :span="12">
                    <el-input
                        v-model="queryParam.Filter"
                        placeholder="快速筛选"
                    >
                        <i
                            slot="suffix"
                            class="el-input__icon el-icon-search"
                        ></i>
                    </el-input>
                </el-col>
                <!-- <el-col :span="12">
          <el-button type="info" icon="el-icon-refresh" class="pull-right" size="medium">刷新</el-button>
        </el-col>-->
            </el-row>
            <div style="width: 100%; height: 20px"></div>
            <el-table :data="tableData" size="mini" style="width: 100%" border>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-dropdown
                            trigger="click"
                            class="international"
                            @command="handleSet"
                        >
                            <el-button type="primary" size="mini">
                                操作
                                <i class="el-icon-arrow-down"></i>
                            </el-button>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item
                                    :command="{
                                        type: 'edit',
                                        id: scope.row.id
                                    }"
                                    v-if="
                                        isGranted(
                                            'Pages.Administration.Users.Edit'
                                        )
                                    "
                                    >修改</el-dropdown-item
                                >
                                <el-dropdown-item
                                    :command="{
                                        type: 'perm',
                                        id: scope.row.id
                                    }"
                                    v-if="
                                        isGranted(
                                            'Pages.Administration.Users.ChangePermissions'
                                        )
                                    "
                                    >权限</el-dropdown-item
                                >
                                <el-dropdown-item
                                    :command="{
                                        type: 'dele',
                                        id: scope.row.id
                                    }"
                                    v-if="
                                        isGranted(
                                            'Pages.Administration.Users.Delete'
                                        )
                                    "
                                    >删除</el-dropdown-item
                                >
                                <el-dropdown-item
                                    :command="{
                                        type: 'unlock',
                                        id: scope.row.id
                                    }"
                                    >解锁</el-dropdown-item
                                >
                                <el-dropdown-item
                                    v-if="
                                        isGranted(
                                            'Pages.Administration.Users.ResetPwd'
                                        )
                                    "
                                    :command="{
                                        type: 'resetpassword',
                                        id: scope.row.id
                                    }"
                                    >重置密码</el-dropdown-item
                                >
                            </el-dropdown-menu>
                        </el-dropdown>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="userName"
                    label="用户名"
                ></el-table-column>
                <el-table-column prop="name" label="姓名"></el-table-column>
                <!-- <el-table-column prop="name" label="名字"></el-table-column>
        <el-table-column prop="surname" label="姓氏"></el-table-column> -->
                <el-table-column prop="roleName" label="角色"></el-table-column>
                <el-table-column
                    prop="emailAddress"
                    label="邮箱地址"
                ></el-table-column>
                <el-table-column label="邮箱验证">
                    <template slot-scope="scope">{{
                        scope.row.isEmailConfirmed ? '是' : '否'
                    }}</template>
                </el-table-column>
                <el-table-column label="激活">
                    <template slot-scope="scope">{{
                        scope.row.isActive ? '是' : '否'
                    }}</template>
                </el-table-column>
                <el-table-column
                    prop="lastLoginTimeStr"
                    label="上次登录时间"
                ></el-table-column>
                <el-table-column
                    prop="creationTimeStr"
                    label="创建时间"
                ></el-table-column>
            </el-table>
            <pagerBar
                ref="refPagerBar"
                :apiURL="getDataUrl"
                :GetData="initData"
                :queryParam="queryParam"
                :errorFunc="closeOpenloading"
            ></pagerBar>
        </el-card>
        <!-- <user-dialog
      ref="userDialog"
      v-bind:Ctitle="Ctitle"
      v-bind:formLabel="formLabel"
      v-bind:allroles="allroles"
      @initData="initData"
    ></user-dialog>-->
        <!-- <el-dialog v-el-drag-dialogog ref="userDialog" v-bind:Ctitle="Ctitle" :id="currentid" :Refresh="Refresh"></el-dialog> -->
        <user-dialog
            ref="userDialog"
            v-bind:Ctitle="Ctitle"
            :id="currentid"
            :Refresh="Refresh"
        ></user-dialog>
        <el-dialog
            :before-close="handleClose"
            :visible.sync="showTree"
            width="40%"
            title="权限"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
        >
            <el-tree
                ref="tree"
                show-checkbox
                :data="treeData"
                :props="defaultProps"
                node-key="name"
                :default-expanded-keys="defaultExpand"
                :auto-expand-parent="true"
                highlight-current
                :expand-on-click-node="false"
                class="filter-tree"
            ></el-tree>

            <el-alert
                title="如果您正在更改自己的权限，则可能需要刷新页面（F5），以使您所做的更改生效！"
                type="warning"
                style="margin-top: 15px"
            ></el-alert>
            <span slot="footer" class="dialog-footer">
                <el-button @click="saveGrantedPermissionNames" type="primary"
                    >确定</el-button
                >
            </span>
        </el-dialog>
    </div>
</template>

<script>
import axios from 'axios'
import userDialog from '@/views/user/dialog'
import config from '@/common/config.js'
import AjaxHelper from '@/common/js/AjaxHelper'
import pagerBar from '@/views/pager/pagerBar'
import Vue from 'vue'
export default {
    components: {
        'user-dialog': userDialog,
        pagerBar
    },
    data() {
        return {
            openloading: true,
            defaultExpand: [], //默认展开第一级菜单
            getDataUrl: config.BASE_Middle_API + 'User/GetUsers', //获取用户信息
            deleUrl: config.BASE_Middle_API + 'User/DeleteUser', //删除用户信息
            getRoleDataUrl: config.BASE_Middle_API + 'Role/GetRoles', //获取权限信息
            getAllPermissionsUrl:
                config.BASE_Middle_API + 'Permission/GetAllPermissions', //获取所有权限信息
            getGranted:
                config.BASE_Middle_API +
                'User/GetUserGrantedPermissionsForEdit', //编辑时获取用户的权限
            savePermDataUrl:
                config.BASE_Middle_API + 'User/UpdateUserPermissions', //保存用户的权限
            unlockUrl: config.BASE_Middle_API + 'User/UnlockUser', //解锁
            resetPwdUrl: config.BASE_Middle_API + 'User/ResetPwd',
            excelUrl: config.BASE_Middle_API + 'User/GetUsersToExcel', //导出
            Visible: false,
            showTree: false,
            activeName: 'first',
            tableData: [],
            formLabel: {
                id: null,
                userName: '',
                name: '',
                surname: '',
                phoneNumber: '',
                emailAddress: '',
                roles: []
            },
            Ctitle: '添加用户',
            // allroles: null,
            queryParam: { Filter: '' },
            treeData: null,
            currentid: null,
            formPermissions: null,
            formPermissionsDefault: null,
            defaultProps: {
                id: 'name',
                label: 'displayName',
                children: 'children'
            }
        }
    },
    created: function () {
        this.initPermissionData()
    },
    methods: {
        getTreeData(list) {
            let dataArray = []
            list.forEach(function (data) {
                let level = data.level
                if (level == 0) {
                    let objTemp = {
                        // id: data.id,
                        name: data.name,
                        displayName: data.displayName,
                        // order: data.order,
                        parentName: data.parentName
                    }
                    dataArray.push(objTemp)
                    if (data.isGrantedByDefault) {
                        this.formPermissionsDefault.push(data.name)
                    }
                }
            })
            return this.data2treeDG(list, dataArray)
        },
        data2treeDG(datas, dataArray) {
            for (let j = 0; j < dataArray.length; j++) {
                let dataArrayIndex = dataArray[j]
                let childrenArray = []
                let name = dataArrayIndex.name
                for (let i = 0; i < datas.length; i++) {
                    let data = datas[i]
                    let parentName = data.parentName
                    if (parentName == name) {
                        //判断是否为儿子节点
                        let objTemp = {
                            name: data.name,
                            displayName: data.displayName,
                            parentName: data.parentName
                        }
                        if (data.isGrantedByDefault) {
                            this.formPermissionsDefault.push(data.name)
                        }
                        childrenArray.push(objTemp)
                    }
                }
                dataArrayIndex.children = childrenArray
                if (childrenArray.length > 0) {
                    //有儿子节点则递归
                    this.data2treeDG(datas, childrenArray)
                }
            }
            return dataArray
        },
        initPermissionData() {
            const _this = this
            AjaxHelper.get(_this.getAllPermissionsUrl)
                .then(function (response) {
                    if (response.success) {
                        _this.treeData = _this.getTreeData(
                            response.result.items
                        )
                    }
                })
                .catch(function (error) {
                    console.log(error)
                })
        },

        // initRoleData() {
        //   const _this = this;
        //   AjaxHelper.get(_this.getRoleDataUrl)
        //     .then(function(response) {
        //       if (response.success) {
        //         _this.allroles = response.result.items;
        //       }
        //     })
        //     .catch(function(error) {
        //       console.log(error);
        //     });
        // },
        initData(d) {
            const _this = this
            _this.tableData = d
            _this.openloading = false
        },
        closeOpenloading() {
            this.openloading = false
        },
        handleClose(d) {
            d()
        },
        add() {
            this.Ctitle = '添加用户'
            this.currentid = null
            this.$refs.userDialog.createDialog()
        },
        clearformLabel() {
            this.formLabel.id = 0
            this.formLabel.userName = ''
            this.formLabel.name = ''
            this.formLabel.surname = ''
            this.formLabel.phoneNumber = ''
            this.formLabel.emailAddress = ''
            this.formLabel.roles = []
        },
        handleSet(command) {
            this.clearformLabel()
            if (command.type == 'edit') {
                //编辑
                this.Ctitle = '编辑用户'
                // this.formLabel = command.data;
                this.currentid = command.id
                this.$refs.userDialog.createDialog()
            }
            if (command.type == 'perm') {
                //权限
                this.initPermissionData()
                this.currentid = command.id
                this.getperm(command.id)
            }
            if (command.type == 'unlock') {
                //解锁
                this.unlock(command.id)
            }
            if (command.type == 'dele') {
                //删除
                this.dele(command.id)
            }
            if (command.type == 'resetpassword') {
                this.resetPassword(command.id)
            }
        },
        saveGrantedPermissionNames() {
            const _this = this
            let PermissionCheck = _this.$refs.tree.getCheckedKeys()
            let PermissionHalfCheck = _this.$refs.tree.getHalfCheckedKeys()
            //合并半选和全选的权限
            PermissionCheck.push.apply(PermissionCheck, PermissionHalfCheck)
            AjaxHelper.put(_this.savePermDataUrl, {
                id: _this.currentid,
                grantedPermissionNames: PermissionCheck
            })
                .then(function (response) {
                    if (response.success) {
                        _this.$message({
                            type: 'success',
                            message: '操作成功'
                        })
                        _this.Refresh()
                        _this.showTree = !_this.showTree
                    } else {
                        _this.$message({
                            type: 'error',
                            message: response.Messages[0]
                        })
                    }
                })
                .catch(function (error) {
                    _this.$message({
                        type: 'error',
                        message: error
                    })
                })
        },
        getperm(id) {
            const _this = this
            AjaxHelper.get(_this.getGranted, {
                Id: id
            })
                .then(function (response) {
                    if (response.success) {
                        _this.formPermissions = response.result
                        if (
                            _this.formPermissionsDefault &&
                            _this.formPermissions
                        ) {
                            _this.formPermissions = $.unique(
                                _this.formPermissions.concat(
                                    _this.formPermissionsDefault
                                )
                            )
                        }
                        if (
                            _this.formPermissionsDefault &&
                            !_this.formPermissions
                        ) {
                            _this.formPermissions = _this.formPermissionsDefault
                        }
                        _this.defaultExpand = _this.formPermissions

                        if (_this.defaultExpand.length == 0) {
                            _this.defaultExpand = ['Pages']
                        }
                        _this.$refs.tree.setCheckedKeys(_this.formPermissions)
                    }
                })
                .catch(function (error) {
                    console.log(error)
                })
            this.showTree = true
        },
        unlock(id) {
            const _this = this
            AjaxHelper.post(_this.unlockUrl, { Id: id })
                .then(function (response) {
                    if (response.success) {
                        _this.$message({
                            type: 'success',
                            message: '解锁成功!'
                        })
                        _this.Refresh()
                    }
                })
                .catch(function (error) {
                    console.log(error)
                })
        },
        resetPassword(id) {
            const _this = this
            _this
                .$confirm(
                    '确定要重置该用户的密码吗?密码将被重置为123456',
                    '提示',
                    {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning',
                        center: true
                    }
                )
                .then(() => {
                    AjaxHelper.post(_this.resetPwdUrl, { Id: id }).then(
                        function (response) {
                            if (response.success) {
                                _this.$message({
                                    type: 'success',
                                    message: '重置成功!'
                                })
                                _this.Refresh()
                            }
                        }
                    )
                })
                .catch(function (error) {
                    console.log(error)
                })
        },
        dele(id) {
            const _this = this
            _this
                .$confirm('确定删除该用户吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: true
                })
                .then(() => {
                    AjaxHelper.delete(_this.deleUrl, { Id: id })
                        .then(function (response) {
                            if (response.success) {
                                _this.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                })
                                _this.Refresh()
                            }
                        })
                        .catch(function (error) {
                            // _this.$message({
                            //   type: "danger",
                            //   message: error
                            // });
                        })
                })
                .catch((e) => {
                    _this.$message({
                        type: 'info',
                        message: '已取消删除'
                    })
                })
        },
        excel() {
            const _this = this
            AjaxHelper.get(_this.excelUrl)
                .then(function (response) {
                    if (response.success) {
                        const url =
                            config.remoteUrl +
                            '/File/DownloadTempFile?fileType=' +
                            response.result.fileType +
                            '&fileToken=' +
                            response.result.fileToken +
                            '&fileName=' +
                            response.result.fileName
                        window.open(url)
                    }
                })
                .catch(function (error) {
                    _this.$message({
                        type: 'danger',
                        message: error
                    })
                })
        },
        Refresh() {
            this.$refs.refPagerBar.Refresh()
        }
    }
}
</script>

<style scoped>
.el-card {
    height: calc(100vh - 217px) !important;
    overflow-y: auto;
}
</style>
